export enum ConfigType {
  CONTENT = "CONTENT",
  CONTRACT = "CONTRACT",
  THEME = "THEME",
}
